import React from 'react';
import styled from 'styled-components';
import {handleTitle, handlePropertyFeatures, handleTypeTitle} from "../helpers/property_helpers";
import Badges from "@atoms/badges";
import Icon from "@atoms/icon";
import PlayWhiteIcon from "@icons/play-white.svg";

const GridCardPropertyInfo = ({property, selectedFiltersDistrict, selectedCityFilter, videoCount}) => {

    return (
        <figcaption className="w-100">
            <Card className="position-relative h-100">

                <TypeTitle>{handleTypeTitle(property.deal_type, property.type, property.villa_type)}</TypeTitle>

                <h3 className="d-flex align-items-center justify-content-between">
                    <Address className="text-ellipsis">{handleTitle(property, false, selectedCityFilter, selectedFiltersDistrict, true, true)}</Address>

                    {
                        (videoCount > 0) ?
                            <Badges color="video" className="mr-8 d-none d-lg-inline-flex align-items-center">
                                <Icon width={8} height={8} className="ml-4"><PlayWhiteIcon/></Icon>
                                <span>ویدیو</span>
                            </Badges>
                            : ''
                    }
                </h3>

                {/*<Details>{handlePropertyFeatures(property, 3)}</Details>*/}

            </Card>
        </figcaption>
    );
};

export default React.memo(GridCardPropertyInfo);


const Card = styled.div`


  @media (max-width: ${props => props.theme.screenXsMax}) {
    display: block;
    width: 100%;
    height: auto !important;
    margin-top: 0;
    margin-right: 0;
    padding: 0;
  }
`;

const Title = styled.div`
  line-height: 1;
`;

const TypeTitle = styled.span`
  font-size: 12px;
  color: ${props => props.theme.black};
  font-weight: 300;
  line-height: 1.35;
`;

const Address = styled.address`
  font-size: 16px !important;
  color: ${props => props.theme.black};
`;

const Details = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  .details-segment {
    font-size: 14px;
    line-height: 1.8;

    &:after {
      content: '.';
      font-size: ${props => props.theme.fontSizeBase};
      font-weight: 400;
      padding: 0 4px;
      display: inline-block;
      vertical-align: middle;
    }

    &:last-child {
      &:after {
        content: '';
        clear: both;
      }
    }
  }
`;